export default "__VITE_ASSET__DPQyYVb5__"